import { BooleanValueProperty } from './properties/boolean-property.model';
import { ImageProperty } from './properties/image-property.model';
import { TextProperty } from './properties/text-property.model';
import { Widget } from './form-widget.model';

export class FbBeforeAfterWidget extends Widget {
  public override title = 'Before After';
  public override name = 'fb-beforeafter';

  constructor(name: string, data: any = {}) {
    super();

    this.name = name;
    this.properties = this.defaultProperties(data.properties);
  }

  defaultProperties(props: any = {}) {
    const properties = {
      text: new TextProperty({ value: props.text ? props.text.value : 'Label 1' }),
      items: props.items,
      hideLabel: new BooleanValueProperty({
        value: props.hideLabel ? props.hideLabel.value : false,
      }),
    };
    return properties;
  }
}
